(function ($) {
  $(document).on("favorites-cleared", function (event, button) {
    location.reload();
  });
})(jQuery);
